module.exports = "/assets/data/9f9d8a819661b28326d51ef09e26700d-LN12.data.json";